import * as Yup from "yup";

export const QuantityReserveSchema = Yup.object().shape({
    sku: Yup.string().required("Поле обязательно к заполнению"),
    count: Yup.number()
        .required("Пожалуйста, укажите количество")
        .min(1, "Значение должно быть больше 0")
        .transform((value) => (isNaN(value) ? undefined : value)),
});
